export default __webpack_public_path__ + "static/media/lantmannen-logo.f0236f3b.png";